module.exports = __webpack_public_path__ + "static/media/icon.615e0e40.png";